import { useSyncExternalStore } from 'react'

const KEY = 'leazepro.sidebar.collapsed'
const listeners = new Set<() => void>()

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

// Remembered in this browser only.
export function setSidebarCollapsed(collapsed: boolean) {
  try {
    localStorage.setItem(KEY, collapsed ? '1' : '0')
  } catch {
    // Private windows and blocked storage: the choice just lasts until reload.
  }
  memory = collapsed
  listeners.forEach((l) => l())
}

let memory: boolean | null = null

export function useSidebarCollapsed(): boolean {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb)
      return () => listeners.delete(cb)
    },
    () => memory ?? (memory = read()),
    () => false,
  )
}

/** Sidebar width as a CSS length; AppShell exposes it as `--shell-sidebar` for fixed bars. */
export const sidebarWidth = (collapsed: boolean) => (collapsed ? '4.5rem' : '16rem')
